/*!
 * doTERRA Web-UI
 * http://www.doterra.com
 *
 * Copyright 2019 doTERRA Holdings, LLC
 * All Rights Reserved
 */

const i18nCache = {};

const defaultCityLineFormat = '$(town), $(region) $(postalCode)';
const defaultUseShortRegion = true;
const defaultNameFormat = '$(firstName) $(lastName)';

export const text = (key, attributes) => {
  return textBase(key, attributes, localText);
};

export const textBase = (key, attributes, array) => {
  let value = i18nCache[key];
  if (!value) {
    value = array[key];
    if (!value) {
      return key;
    }
    i18nCache[key] = value;
  }
  if ((attributes === undefined || attributes === null) || (attributes.length !== undefined && attributes.length === 0)) {
    return value;
  }
  let _attributes = typeof attributes === 'string' || typeof attributes === 'number' || typeof attributes === 'boolean' || attributes.length === undefined ? [attributes] : attributes;
  for (let n = 0; n < _attributes.length; n++) {
    let param = `{${n}}`;
    if (value.indexOf(param) >= 0) {
      value = value.replace(param, _attributes[n]);
    }
  }
  return value;
};

export const formatCityLine = (town, region, postalCode, format) => {
    format = format || defaultCityLineFormat;
    let retVal = format.replace('$(town)', town || '');
    retVal = retVal.replace('$(region)', region || '');
    return retVal.replace('$(postalCode)', postalCode || '');
};

export const formatAddressCityLine = (address, useShortRegion, format) => {
    if (!address) {
        return '';
    }
    let useShort = useShortRegion === undefined ? defaultUseShortRegion : useShortRegion;
    return formatCityLine(address.town, useShort ? address.region.isocodeShort : address.region.name, address.postalCode, format);
};

export const formatName = (firstName, lastName, middleOrFormat, format) => {
    format = format || defaultNameFormat;
    let middle = middleOrFormat;
    if (middle && middle.length > 0 && middle.includes('$(')) {
        middle = undefined;
        format = middleOrFormat;
    }
    let retVal = format.replace('$(firstName)', firstName || '');
    retVal = retVal.replace('$(lastName)', lastName || '');
    if (format.includes('$(middle)')) {
        retVal = retVal.replace('$(middle)', middle || '');
    }
    return retVal;
};
